import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneWorkflowSlug';
const QS_TYPE: QueryStateSchema['type'] = 'workflowTemplate';

export const useOpenWorkflowPane = (): ((args: { workflowSlug: string }) => void) => {
  const [workflowSlugDeprecated, setWorkflowSlug] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (workflowSlugDeprecated) {
      setWorkflowSlug(null);
      setState(backwardsCompatabilityFactory({ id: workflowSlugDeprecated, type: QS_TYPE }));
    }
  }, [workflowSlugDeprecated]);

  return ({ workflowSlug }): void => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: workflowSlug,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
